/**
 * @param {string} base
 */
window.PrintersApi = (function(base) {
  /**
   * @param {string} url
   * @param {string} method
   * @param {object} body
   *
   * @returns {Promise<object|object[]}
   */
  const makeRequest = (url, method = 'GET', body = { }) => new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();

    req.responseType = 'json';

    req.onload = () => resolve(req.response);
    req.onabort = () => reject();
    req.onerror = () => reject();

    req.open(method, url);
    req.setRequestHeader('Content-Type', 'application/json');
    req.send(JSON.stringify(body));
  });

  /**
   * @param {string} endpoint
   * @param {object} params
   *
   * @returns {string}
   */
  const makeUrl = (endpoint, params = { }) => {
    const url = new URL(base + endpoint);

    Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));

    return url.toString();
  }

  /**
   * @param {object} [params]
   * @param {string} [params.name]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<object[]>}
   */
  const getManufacturers = (params = { }) => makeRequest(makeUrl('/manufacturers', params));

  /**
   * @param {number|string} id
   *
   * @returns {Promise<object|null>}
   */
  const getManufacturerById = (id) => makeRequest(makeUrl(`/manufacturers/${id}`));

  /**
   * @param {object} [params]
   * @param {string} [params.name]
   * @param {number|string} [params.manufacturer_id]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<object[]>}
   */
  const getSeries = (params = { }) => makeRequest(makeUrl('/series', params));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getSeriesById = (id) => makeRequest(makeUrl(`/series/${id}`));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getSeriesManufacturer = (id) => makeRequest(makeUrl(`/series/${id}/manufacturer`));

  /**
   * @param {object} [params]
   * @param {string} [params.name]
   * @param {number|string} [params.series_id]
   * @param {number|string} [params.manufacturer_id]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<object[]>}
   */
  const getModels = (params = { }) => makeRequest(makeUrl('/models', params));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getModelById = (id) => makeRequest(makeUrl(`/models/${id}`));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getModelSeries = (id) => makeRequest(makeUrl(`/models/${id}/series`));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getModelManufacturer = (id) => makeRequest(makeUrl(`/models/${id}/manufacturer`));

  /**
   * @param {number|string} id
   *
   * @return {Promise<object>}
   */
  const getBechlemByBechlemId = (id) => makeRequest(makeUrl(`/bechlem/${id}`));

  /**
   * @param {number|string} id
   * @param {object} [params]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @returns {object[]}
   */
  const getArticlesByBechlemId = (id, params = { }) => makeRequest(makeUrl(`/bechlem/${id}/articles`, params));

  /**
   * @param {number[]} ids
   * @param {object} [params]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<object[]>}
   */
  const getModelsByBechlemIds = (ids, params = { }) => makeRequest(makeUrl(`/bechlem`, params), 'POST', { ids })

  /**
   * @param {object} [params]
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @returns {Promise<object[]>}
   */
  const getArticles = (params = { }) => makeRequest(makeUrl('/articles', params));

  /**
   * @param {number|string} id
   *
   * @returns {Promise<object>}
   */
  const getArticleById = (id) => makeRequest(makeUrl(`/articles/${id}`));

  /**
   * @param {object} params
   * @param {string} params.sSearch
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<{ results: object[], total: number}>}
   */
  const searchArticles = (params) => makeRequest(makeUrl('/smart-search/articles', params));

  /**
   * @param {object} params
   * @param {string} params.sSearch
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<{results: object[], total: number}>}
   */
  const searchModels = (params) => makeRequest(makeUrl('/smart-search/models', params));

  /**
   * @param {object} params
   * @param {string} params.sSearch
   * @param {number} [params.limit]
   * @param {number} [params.offset]
   *
   * @return {Promise<{ results: string[], total: number}>}
   */
  const searchAutocomplete = (params) => makeRequest(makeUrl('/smart-search/autocomplete', params));

  /**
   * @return {Promise<{ version: string }>}
   */
  const getVersion = () => makeRequest(makeUrl('/version'));

  return {
    getManufacturers,
    getManufacturerById,
    getSeries,
    getSeriesById,
    getSeriesManufacturer,
    getModels,
    getModelById,
    getModelSeries,
    getModelManufacturer,
    getBechlemByBechlemId,
    getArticlesByBechlemId,
    getModelsByBechlemIds,
    getArticles,
    getArticleById,
    searchArticles,
    searchModels,
    searchAutocomplete,
    getVersion
  };
})(window.location.hostname.endsWith('.myshopify.com') ? 'https://devsuche.kolero.de/_extern/search-api/api/v3' : 'https://suche.kolero.de/_extern/search-api/api/v3');
